export default __webpack_public_path__ + "static/media/Premonition_3_2.b79f75d7.png";